export enum CircuitHistoryActionState {
  UNDO = '[History] Undo Action',
  REDO = '[History] Redo Action',
}
